/**
 * @class reportAnnotationConstants
 */
import { tableConstantsFactory } from './tableConstantsFactory';
const prefix = 'REPORTANNOTATION';
const reportAnnotationConstants = tableConstantsFactory(prefix);
reportAnnotationConstants.CREATE_INFO = "".concat(prefix, "_CREATE_INFO");
reportAnnotationConstants.CREATE_FREETEXT = "".concat(prefix, "_CREATE_FREETEXT");
reportAnnotationConstants.CREATE_HIGHLIGHT = "".concat(prefix, "_CREATE_HIGHLIGHT");
reportAnnotationConstants.CREATE_INK = "".concat(prefix, "_CREATE_INK");
reportAnnotationConstants.CREATE_LINE = "".concat(prefix, "_CREATE_LINE");
reportAnnotationConstants.CREATE_ISSUE = "".concat(prefix, "_CREATE_ISSUE");
reportAnnotationConstants.RESET = "".concat(prefix, "_RESET");
reportAnnotationConstants.DELETE_SUCCESS = "".concat(prefix, "_DELETE_SUCCESS");
reportAnnotationConstants.DELETE_FAILURE = "".concat(prefix, "_DELETE_FAILURE");
reportAnnotationConstants.SELECT_BY_TYPE_ID = "".concat(prefix, "_SELECT_BY_TYPE_ID");
export default reportAnnotationConstants;